









import { defineComponent, PropType } from '@vue/composition-api';
import { PaymentQuery } from '@ligo/shared/models';
import { PaymentService } from '@ligo/dashboard/customer/store';

export default defineComponent({
  name: 'MolliePayment',
  props: {
    uuid: {
      type: String,
      required: true
    },
    originUrl: {
      type: String,
      required: true
    },
    query: Object as PropType<PaymentQuery>
  },
  setup(props) {
    async function goToMollieCheckout() {
      const response = await PaymentService.createMolliePayment(props.uuid);
      const url = response.data.payment_link;
      window.open(url, '_top');
    }
    return {
      goToMollieCheckout
    };
  }
});
